"use client";

import Link from "next/link";

import { usePublicFrontendTranslation } from "@smartmanager/shell-ui/shared/i18n/usePublicFrontendTranslation";

export default function NotFoundPage() {
  const t = usePublicFrontendTranslation();

  return (
    <main
      className="relative flex min-h-screen w-full items-center justify-center overflow-hidden px-6 text-white"
      style={{ background: "radial-gradient(circle at 50% 32%, rgba(48, 130, 255, 0.22), transparent 34%), #03060d" }}
    >
      <div aria-hidden="true" className="absolute inset-0 opacity-30" style={{ backgroundImage: "linear-gradient(rgba(255,255,255,.035) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.035) 1px, transparent 1px)", backgroundSize: "42px 42px" }} />
      <section className="relative z-10 max-w-xl text-center">
        <p className="mb-5 text-xs font-semibold uppercase tracking-[0.34em] text-blue-300">Smart Manager · 404</p>
        <h1 className="text-balance text-4xl font-semibold tracking-tight sm:text-6xl">
          {t("This space does not exist.")}
        </h1>
        <p className="mx-auto mt-5 max-w-md text-base leading-7 text-slate-300 sm:text-lg">
          {t("The address may be outdated or mistyped. Return home to continue securely.")}
        </p>
        <Link
          href="/"
          className="mt-9 inline-flex min-h-12 items-center justify-center rounded-full border border-blue-300/40 bg-blue-500/20 px-7 py-3 text-sm font-semibold text-white transition hover:border-blue-200 hover:bg-blue-500/30 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-blue-300"
        >
          {t("Return home")}
        </Link>
      </section>
    </main>
  );
}
